import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

export enum CustomMessageTagChannel {
  airbnb = 'airbnb',
  bookingDotCom = 'booking_dot_com',
  google = 'google',
  homeAway = 'home_away',
  uplisting = 'uplisting',
}

export default class CustomMessageTagModel extends Model {
  @attr('string') name!: string;
  @attr('string') description!: string;
  @attr('string', { defaultValue: '' }) content!: string;
  @attr('array', {
    defaultValue() {
      return [];
    },
  })
  channels!: CustomMessageTagChannel[];

  @cached
  get tagCode(): string {
    return this.name ? `{{${this.name}}}` : '';
  }

  @cached
  get isPersisted(): boolean {
    return !!this.id;
  }

  @cached
  get order(): number {
    if (!this.isPersisted) {
      return 0;
    }

    return Number(this.id);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'custom-message-tag': CustomMessageTagModel;
  }
}
